export const POST_OFFICE_KILL_SWITCH = 'killswitch_post_office_in_jira';
